import $ from 'jquery';

$.fn.extend({
	clickEffect(element, effect = 'circle') {

		function addCircleEffect() {
			$(element).addClass('click-effect').delay(500).queue(() => {
				$(element).removeClass('click-effect').dequeue();
			});
		}

		if (effect === 'circle') {
			addCircleEffect();
		}
		return this; // maintain jQuery chainability
	}
});



// WEBPACK FOOTER //
// ./mobile-core/src/libs/jquery-click-effect.js